import React, { createContext, useCallback, useContext, useState } from 'react'
import SuccessSnackbar from '../../components/Snackbar/SuccessSnackbar'
import ErrorSnackbar from '../../components/Snackbar/ErrorSnackbar'
import InfoSnackbar from '../../components/Snackbar/InfoSnackbar'

interface ToastMessage {
  id: number
  type: 'success' | 'error' | 'info' | 'warning'
  message: string | string[] | JSX.Element
}

interface ToastContextData {
  showToast: (
    message: ToastMessage['message'],
    type?: ToastMessage['type']
  ) => void
}

const ToastContext = createContext<ToastContextData | undefined>(undefined)

export function ToastProvider({
  children,
}: { children: React.ReactNode }) {
  const [currentToast, setCurrentToast] = useState<ToastMessage | null>(null)

  const showToast = useCallback(
    (message: ToastMessage['message'], type: ToastMessage['type'] = 'info') => {
      setCurrentToast({ id: Date.now(), message, type })
    },
    []
  )

  const handleClose = () => {
    setCurrentToast(null)
  }

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}

      {/* Renderiza seu componente Snackbar */}
      {currentToast?.type === 'info' && (
        <InfoSnackbar
          open={!!currentToast}
          onClose={handleClose}
          autoHideDuration={4000}
        >
          {currentToast.message}
        </InfoSnackbar>
      )}
      {currentToast?.type === 'success' && (
        <SuccessSnackbar
          open={!!currentToast}
          onClose={handleClose}
          autoHideDuration={4000}
        >
          {currentToast.message}
        </SuccessSnackbar>
      )}
      {currentToast?.type === 'error' && (
        <ErrorSnackbar open={!!currentToast} onClose={handleClose}>
          {currentToast.message}
        </ErrorSnackbar>
      )}
    </ToastContext.Provider>
  )
}

export const useToast = (): ToastContextData => {
  const context = useContext(ToastContext)
  if (!context) {
    throw new Error('useToast deve ser usado dentro do ToastProvider')
  }
  return context
}
